import { ensureContactCorn } from '@eigtech/contacts-util'
import { queryOptions, useQuery, useQueryClient, useSuspenseQuery } from '@eigtech/ui-shared-api'
import { assignmentsQueryKeys, getAssignablesForAssignee } from '@eigtech/ui-shared-assignments'

export function getAssignablesForContactQueryOptions(contactId: string) {
  const contactCorn = ensureContactCorn(contactId)

  return queryOptions({
    queryKey: assignmentsQueryKeys.assignee.assignables(contactCorn),
    queryFn: () => getAssignablesForAssignee({ assigneeId: contactCorn }),
    enabled: !!contactId,
  })
}

export const useGetAssignablesForContact = (contactId: string) =>
  useQuery(getAssignablesForContactQueryOptions(contactId))

export const useGetAssignablesForContactSuspense = (contactId: string) =>
  useSuspenseQuery(getAssignablesForContactQueryOptions(contactId))

export function useInvalidateAssignablesForContact() {
  const queryClient = useQueryClient()

  return function invalidateAssignablesForContact(contactId: string) {
    queryClient.invalidateQueries({
      queryKey: getAssignablesForContactQueryOptions(contactId).queryKey,
    })
  }
}
